export const headerName = {
  add: "Добавить запись",
  edit: "Редактировать запись",
};
export const structuralUnitsData = {
  section: {
    key: "section",
    label: "Наименование структурного подразделения",
    type: "text",
    required: true,
  },
};

export const getDataStructuralUnitsModal = () => structuralUnitsData;
